// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-form-field-outer-wrapper .mat-mdc-form-field {
  width: 100%;
}
.mat-form-field-outer-wrapper.big-size {
  height: 200px;
}
.mat-form-field-outer-wrapper.big-size .mat-mdc-form-field {
  height: 100%;
}
.mat-form-field-outer-wrapper.big-size .mat-mdc-form-field .mat-mdc-text-field-wrapper,
.mat-form-field-outer-wrapper.big-size .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex {
  height: 100%;
  width: 100%;
}
.mat-form-field-outer-wrapper.big-size .mat-mdc-form-field .mat-mdc-form-field-infix {
  height: 100%;
}
.mat-form-field-outer-wrapper.big-size .mat-mdc-form-field .mat-mdc-form-field-infix textarea {
  height: 100%;
  resize: none;
}
.mat-form-field-outer-wrapper.big-size .mat-mdc-form-field .mat-mdc-form-field-hint-spacer {
  display: none;
}`, "",{"version":3,"sources":["webpack://./Source/app/fi-form/fi-form-edit/fi-form-edit-form/fi-form-edit-form-general/fi-form-edit-form-general.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;AAGI;EACI,aAAA;AADR;AAGQ;EACI,YAAA;AADZ;AAEY;;EAEI,YAAA;EACA,WAAA;AAAhB;AAEY;EACI,YAAA;AAAhB;AAEgB;EACI,YAAA;EACA,YAAA;AAApB;AAGY;EACI,aAAA;AADhB","sourcesContent":[".mat-form-field-outer-wrapper {\r\n    .mat-mdc-form-field {\r\n        width: 100%;\r\n    }\r\n\r\n    &.big-size {\r\n        height: 200px;\r\n\r\n        .mat-mdc-form-field {\r\n            height: 100%;\r\n            .mat-mdc-text-field-wrapper,\r\n            .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex {\r\n                height: 100%;\r\n                width: 100%;\r\n            }\r\n            .mat-mdc-form-field-infix {\r\n                height: 100%;\r\n\r\n                textarea {\r\n                    height: 100%;\r\n                    resize: none;\r\n                }\r\n            }\r\n            .mat-mdc-form-field-hint-spacer {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
